'use strict';

module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/faye/src/util/cookies/browser_cookies.js
// module id = KJ3N
// module chunks = 0